export default "__VITE_ASSET__B0RqyFG9__"